/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Form, Alert } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import BaseContainer from '../common/BaseContainer';
import ControlHeader from '../common/ControlHeader';
import generateFormikInputs from '../../utils/generateFormikInputs';
import fetch from '../../utils/fetcher';

import {
  formsInputsData, validationSchema, initialValues,
} from './config';
import PrimaryButton from '../common/buttons/PrimaryButton';
import useStyles from './styles';
import { defaultLink } from '../../utils/consts';


const Brand = ({ newBrand }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [brandCreated, setBrandCreated] = useState(false);
  const { t } = useTranslation(['translation'])

  useEffect(() => {
    const doFetch = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/publisher/`);
        const { name, country, redirectUrl } = await res.json();
        setData({ name, country, redirectUrl });
      } catch {
        setError(t('BRAND.SERVER_ERROR'));
      }
    };
    if (!newBrand) {
      doFetch();
    } else {
      setData(initialValues);
    }
  }, [newBrand, t]);

  const submit = (values, { setSubmitting }) => {
    fetch(`${process.env.REACT_APP_API_URL}/publisher/edit`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(values),
    })
      .then(() => {
        setBrandCreated(true);
        // window.location.href = defaultLink;
      })
      .catch((err) => {
        setSubmitting(false);
        setError(err.error);
      });
  };

  const classes = useStyles();

  if (brandCreated) {
    return <Redirect to={newBrand ? '/portal/create' : defaultLink} />;
  }
  return (
    <BaseContainer>
      <ControlHeader
        title={newBrand ? t('BRAND.CREATE_BRAND') : t('BRAND.EDIT_BRAND')}
        showBack={!newBrand}
      />
      {data && (
        <Formik
          initialValues={data}
          onSubmit={submit}
          validationSchema={validationSchema}
        >
          {({
            handleSubmit,
            isSubmitting,
            ...formikProps
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className={classes.inputsGrid}>
                {generateFormikInputs(formsInputsData, formikProps, false)}
              </div>

              { error && <Alert color="danger">{error}</Alert> }

              <PrimaryButton type="submit" className={classes.button} disabled={isSubmitting}>
                {t('BRAND.SAVE_BUTTON')}
              </PrimaryButton>
            </Form>
          )}
        </Formik>
      )}
    </BaseContainer>
  );
};

Brand.defaultProps = {
  newBrand: false,
};

Brand.propTypes = {
  newBrand: PropTypes.bool,
};

export default Brand;
